var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-toolbar',{staticClass:"anim-fadeIn",class:{'show-cookie-concent' : !_vm.cookieConcentAccepted},attrs:{"seperator":"layout-home","extended":_vm.$route.meta.extendToolbar}},[_vm._v(" hey ")])}
var staticRenderFns = []

export { render, staticRenderFns }